import { useSelector } from 'react-redux';
import { useIsMobile } from './useIsMobile';
import { externalHostSelector } from '../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../ConsumerArea/ConsumerAreaConstants';
import { selectCurrentClient } from '../CommonSelectors/CommonAreaSelector';

export const useIsEmbeddedMobile = () => {
  const isMobile = useIsMobile();

  const externalHost = useSelector(externalHostSelector);

  const currentClient = useSelector(selectCurrentClient);

  return (
    isMobile &&
    (currentClient?.HasMobileNavigation ||
      [
        EXTERNAL_HOST.MONETA,
        EXTERNAL_HOST.WEALTHCARE,
        EXTERNAL_HOST.MERIT,
        EXTERNAL_HOST.CARSON,
      ].includes(externalHost))
  );
};
